/**
 * Hook for user signup
 */
import { useMutation } from '@tanstack/react-query';
import { useToast } from '@ui/use-toast';
import { signupUser, type MessageResult, type SignupData } from '@lib/api/auth';
import { toProblem } from '@lib/api/base';

export const useSignup = () => {
  const { toast } = useToast();

  return useMutation<MessageResult, unknown, SignupData>({
    mutationFn: signupUser,
    onSuccess: ({ message }) => {
      // For signup with email verification, user won't be logged in immediately
      toast({
        title: 'Signup Successful',
        description:
          message ||
          'Your account has been created. Please check your email to verify your account.',
      });
    },
    onError: error => {
      const problem = toProblem(error);
      toast({
        title: 'Signup Failed',
        description:
          problem.detail ||
          problem.title ||
          'There was a problem creating your account. Please try again.',
        variant: 'destructive',
      });
    },
  });
};
